export const handleLinkClick = () => {
    window.scrollTo(0, 0);
};
